<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";

import { useUserStore } from "@/store/user";
import { stopBrowserAction, restartBrowserAction } from "@/utils";

dayjs.locale("zh-cn");

const userStore = useUserStore();
const route = useRoute();

const state = reactive({
  locale: zhCN,
});

watch(
  () => route.name,
  () => {
    if (["VideoDetails"].includes(route.name)) {
      stopBrowserAction("contextmenu");
    } else {
      restartBrowserAction("contextmenu");
    }
  },
  {
    immediate: true,
  }
);

onMounted(async () => {
  await userStore.getUserInfo().catch((e) => e);
  await userStore.getSetting((e) => e);
});

const { locale } = toRefs(state);
</script>

<style lang="scss">
#app {
  font-family: BlinkMacSystemFont, -apple-system, Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.page-container {
  font-size: 14px;
  user-select: none;
  -webkit-overflow-scrolling: touch;
}
</style>
